import React from 'react';
import { func } from 'prop-types';
import { withRouter } from 'react-router';
import orderBy from 'lodash/orderBy';
import ReportsMainHeader from './ReportsMainHeader';
import ReportsAccounts from './ReportsAccounts';
import ReportsPeriod from './ReportsPeriod';
import {
  _executeReport,
  _getAllAccountList,
} from '../../../../actions/deActions/reportActions';

const Reports = ({ setView }) => {
  const [accountLoading, setAccountLoading] = React.useState(true);
  const [accounts, setAccounts] = React.useState([]);
  const [inSingleFile, onExportAsSeparateChange] = React.useState(true);
  const [selectedAccounts, setSelectedAccounts] = React.useState([]);

  const [isDateError, setDateError] = React.useState(false);
  const [toDate, setToDate] = React.useState('');
  const [fromDate, setFromDate] = React.useState('');
  const [isAccountError, setAccountError] = React.useState(false);

  const _handleExport = () => {
    if (!toDate || !fromDate) {
      setDateError(true);
    } else {
      setDateError(false);
    }
    const isAccountError = selectedAccounts.length === 0;
    setAccountError(isAccountError);
    if (!isAccountError && toDate && fromDate) {
      const request = {
        from: fromDate,
        to: toDate,
        accounts: selectedAccounts,
        inSingleFile: (selectedAccounts.length <= 1) ? true : !inSingleFile
      };
      _executeReport(request).then(res => {
        if (res) {
          window.open(res, '_blank');
        }
      });
    }
  };
  const _getAllAccounts = () => {
    _getAllAccountList()
      .then(res => {
        setAccountLoading(false);
        const sortedAccounts = orderBy(
          res.data,
          [ac => ac.accountName.toLowerCase()],
          ['asc']
        );
        setAccounts(sortedAccounts);
      })
      .catch(() => {
        setAccountLoading(false);
      });
  };
  React.useEffect(() => {
    _getAllAccounts();
  }, []);

  const _handleAccountsSelect = account => {
    let acc = [...selectedAccounts];
    if (selectedAccounts.includes(account.accountId)) {
      acc = selectedAccounts.filter(i => i !== account.accountId);
    } else {
      acc.push(account.accountId);
    }
    setSelectedAccounts(acc);
  };

  const _handleSelectAllAccount = accounts => {
    setSelectedAccounts(accounts);
  };

  const handleDateChange = (type, value) => {
    if (type === 'from') {
      setFromDate(value);
    }
    if (type === 'to') {
      setToDate(value);
    }
  };

  return (
    <div className="de--main de--target de--flex-col de-o-hidden de--main-pad de--reports">
      <ReportsMainHeader setView={setView} data-test="ReportsMainHeader" />
      <div className="de--reports--main">
        <div className="de--reports--header">
          <div className="de--reports--type">
            <h2>Report(s)</h2>
            <p>Active Targets by Account</p>
          </div>
          <div className="de--reports--export">
            <button
              type="button"
              className="de--btn de--btn__secondary"
              onClick={() => _handleExport()}
              disabled={accounts.length === 0}
            >
              Export
            </button>
          </div>
        </div>
        <div className="de--reports--body">
          <div className="de--reports--section-title">
            <h3>Selections</h3>
          </div>
          <div className="de--reports--section">
            <ReportsPeriod
              handleDateChange={handleDateChange}
              isDateError={isDateError}
              from={fromDate}
              to={toDate}
            />
            <ReportsAccounts
              accountLoading={accountLoading}
              accounts={accounts}
              inSingleFile={inSingleFile}
              onExportAsSeparateChange={onExportAsSeparateChange}
              selectedAccounts={selectedAccounts}
              setSelectedAccounts={_handleAccountsSelect}
              setAllSelectedAccounts={_handleSelectAllAccount}
              isAccountError={isAccountError}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Reports.propTypes = {
  setView: func,
};

export default withRouter(Reports);
